export default __webpack_public_path__ + "static/media/arrow-bottom-blue-icon.cfd5c793.svg";